import type { PayloadAction } from 'modules/global/generic.types';
import * as types from 'modules/kiosks/actionTypes';
import type { FetchKiosksByPaymentTypesSuccessAction, KiosksPage, StoredKiosk } from 'modules/kiosks/types';
import type { EntitySlice } from 'utils/ReduxUtils';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

export const kioskAdapter = createEntityAdapter<StoredKiosk>({ selectId: ({ id }) => id });

const updateManyFromPage = (state: EntitySlice<StoredKiosk>, { payload }: PayloadAction<KiosksPage>) =>
  kioskAdapter.updateMany(state, payload.content);

const updateManyFromDealerPage = (
  state: EntitySlice<StoredKiosk>,
  { payload }: FetchKiosksByPaymentTypesSuccessAction
) => kioskAdapter.updateMany(state, payload.kiosks.content);

export default createReducer(kioskAdapter.getInitialState(), {
  [types.FETCH_KIOSKS_SUCCESS]: updateManyFromPage,
  [types.FETCH_AVAILABLE_RELAYS_SUCCESS]: updateManyFromPage,
  [types.PUT_KIOSK_SUCCESS]: kioskAdapter.addOne,
  [types.POST_KIOSK_SUCCESS]: kioskAdapter.addOne,
  [types.FETCH_KIOSK_SUCCESS]: kioskAdapter.updateOne,
  [types.PATCH_STATUS_SUCCESS]: kioskAdapter.updateOne,
  [types.FETCH_KIOSKS_BY_PAYMENT_TYPES_SUCCESS]: updateManyFromDealerPage,
  [types.DELETE_SUCCESS]: kioskAdapter.removeOne,
});
